module.exports = __webpack_public_path__ + "static/media/step_sku_pending.017fbf4d.svg";